import React from 'react'
import MenuLinks from './MenuLinks'

function Navbar() {
  return (
    <section className='md:block hidden bg-myorangeolor leading-[57px]'>
        <div className='container mx-auto'>
        <div class="flex justify-between items-center w-full">
          <div className='w-[80%]'>
           <MenuLinks set="flex-row" myMargin="mx-7"/>
           </div>
  <div class="flex items-center gap-4 pr-5">
    <a href="https://www.viranihopefoundation.org/" target="_blank" className='text-white font-primary font-medium uppercase'>
      Virani Hope Foundation
    </a>
  </div>
           </div>
        </div>
    </section>
  )
}

export default Navbar